import { PartnerModel } from '../../models/PartnerModel';
import { Retailer } from '../../models/Retailer';

export interface RetailerDTO extends PartnerModel {
  hasRoundAmount: boolean;
  hasAddAmount: boolean;
  isLandBased: boolean;
  usesPosOverEfiscal: boolean;
}

export const retailerExtension = (data: RetailerDTO): Retailer => ({ ...data });
export const retailerDTOExtension = (data: Retailer): RetailerDTO => ({ ...data });
